import client from '../session/apiClient';

export default {
  getAccounts: () => {
    return client.get('/v5/accounts').then(x => x.data);
  },
  getAccountsByIds: (accountIds) => {
    return client.get('/v5/accounts', {params: {accountId: accountIds}}).then(x => x.data);
  },
};
